export default __webpack_public_path__ + "static/media/41t.2bba7762.jpg";